import {Authenticated} from './middleware'

export default [

  {
    name: 'sales',
    path: '/',
    redirect: {name: 'sales.list'},
    component: () => import ('../../views/cpanel/sales/index'),
    meta: {
      title: 'Продажи',
      back: 'cpanel.dashboard',
      middleware: Authenticated
    },
    children: [
      {
        name: 'sales.list',
        path: '/',
        component: () => import ('../../views/cpanel/sales/List'),
        meta: {
          title: 'Продажи',
          back: 'cpanel.dashboard',
          middleware: Authenticated
        },
      },

    ]
  },


];
